import axios from "axios";
require('dotenv').config();
const request= axios.create({
    baseURL: process.env.REACT_APP_BASEURl
  })

export default request;